import { IconSearch } from '@tabler/icons-react'
import styled from 'styled-components'

import { useProject, BUILDER_KEY } from '../../context/projectContext'

import { Button } from './BUI/Button'

const Wrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
`

type Props = {
  extra?: React.ReactNode
}

export const EmptyListBuilderSearch: React.FC<Props> = ({ extra }) => {
  const { updateProject, projects } = useProject()

  const setBuilderAsProject = () => {
    updateProject(projects.find((p) => p.id === BUILDER_KEY))
  }

  return (
    <Wrapper>
      <IconSearch size={28} />
      {extra && <span>{extra}</span>}
      <span>
        Can&apos;t find what you&apos;re looking for? Try searching all projects
      </span>

      <Button size="small" onClick={setBuilderAsProject}>
        Search all projects
      </Button>
    </Wrapper>
  )
}
